import React from "react";
export const useEllipseDetection = (ref, callback) => {
    const [isEllipse, setIsEllipseflow] = React.useState(undefined);
    React.useEffect(() => {
        const { current } = ref;
        const trigger = () => {
            const ellipseVal = 
            // current.offsetHeight < current.scrollHeight ||
            current.offsetWidth < current.scrollWidth;
            setIsEllipseflow(ellipseVal);
            if (callback)
                callback(ellipseVal);
        };
        if (current) {
            trigger();
        }
    }, [callback, ref]);
    return isEllipse;
};
